import React from 'react';
import { createRoot } from 'react-dom/client';
import { getLogger } from '../logger.js';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import MobileRedirectPage from '../mobile_redirect/mobile_redirect';
import LoginPage from '../login/login';
import AccessDeniedPage from '../access_denied/access_denied';

const logger = getLogger();

const div = document.querySelector('#app');

if (div) {
    // NOTE: isolate this app: https://redux.js.org/recipes/isolating-redux-sub-apps
    const root = createRoot(div);

    root.render(
        <BrowserRouter>
            <Routes>
                <Route path="/pre_landing" element={<LoginPage />} />
                <Route path="/access_denied" element={<AccessDeniedPage />} />
                <Route
                    path="/mobile_redirect"
                    element={<MobileRedirectPage />}
                />
            </Routes>
        </BrowserRouter>,
    );

    logger.info('Application rendered.');
} else {
    logger.error('Unable to locate the body to append the app div onto.');

    throw new Error(
        'Unable to mount application due to a lack of an HTML page to latch onto.',
    );
}
